/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TipMi Admin API
 * Admin console backend API consumed by tipmi-admin-web
 * OpenAPI spec version: v1
 */

export type FinanceChannelFieldAvailability =
  (typeof FinanceChannelFieldAvailability)[keyof typeof FinanceChannelFieldAvailability];

export const FinanceChannelFieldAvailability = {
  AVAILABLE: 'AVAILABLE',
  INCOMPLETE_FEES: 'INCOMPLETE_FEES',
  COMING_SOON: 'COMING_SOON',
} as const;
